import type { AdminUpcomingAmendmentsResponse, ApiResponse } from '@safetyhub/shared';
import api from './api';

/**
 * **시행 예정 개정** API 클라이언트 — 2단계 L25(US-0724). 「법정 의무 카탈로그」 화면 위 패널이 쓴다.
 *
 * 서버 `GET /admin/legal-obligations/upcoming-amendments`(권한 `legal-obligation-catalog` 상속). 계약 정본은 shared
 * `features/legal-obligation-catalog.ts`의 `AdminUpcomingAmendment*`다. 수신 범위는 **운영사만**(사용자 결정
 * 2026-10-28)이라 web에는 짝이 없다.
 *
 * 왜 `legalObligationCatalog.ts`에 두지 않았나: 그 모듈의 `legalObligationCatalogApi`를 화면 spec이 **팩토리로
 * 통째 mock**한다(`list`·`update`·`history`만 준다) — 같은 객체에 메서드를 더하면 그 spec에서 이 패널이
 * `undefined` 호출로 죽는다. 모듈을 갈라 각 spec이 따로 mock하게 했다.
 */

/** 카탈로그 목록 키(`['admin','legal-obligations']`)의 하위 — 그 접두로 무효화하면 함께 새로 읽힌다 */
export const UPCOMING_AMENDMENTS_QUERY_KEY = ['admin', 'legal-obligations', 'upcoming-amendments'] as const;

export async function getUpcomingAmendments(): Promise<AdminUpcomingAmendmentsResponse> {
  const res = await api.get<ApiResponse<AdminUpcomingAmendmentsResponse>>(
    '/admin/legal-obligations/upcoming-amendments',
  );
  if (res.data.data === null) {
    throw new Error('서버 응답에 본문이 없습니다. 잠시 후 다시 시도해 주세요.');
  }
  return res.data.data;
}
